import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreModule } from "@webapp/core/core.module";
import { FormsModule } from "@angular/forms";
import { UiModule } from "@webapp/ui/ui.module";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { sharedDeclarations, sharedExports } from "@webapp/shared/index";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { RichTextEditorModule } from "@webapp/shared/rich-text-editor/rich-text-editor.module";

@NgModule({
  imports: [CoreModule, BsDropdownModule, CommonModule, FormsModule, UiModule, RichTextEditorModule],
  declarations: [...sharedDeclarations],
  exports: [...sharedExports, CommonModule],
  providers: [Ng1StateProxyProvider],
})
export class SharedModule {}
